import {
    getLang,
    labelHelper,
    trField,
    urlHelper,
    urlHelperWithCustomParam,
    urlHelperWithoutCustomParam
} from "helpers/themeHelpers";
import { IVirtualCatAsset } from "models/Assets/ICategoryAsset";
import { qsStringify } from "helpers/globalHelpers";
import { ICityLiteAsset } from "models/Assets/ICityAsset";

export const linkToFind = (
  {
    basePath = null,
    cities = [],
    neighborhoods = [],
    category = null,
    categoriesId = null,
    subCategory = null,
    dynamicAttributesObjects = [],
    dynamicAttributesIds = null,
    search_type = null,
    term = null,
    page = null,
    allCPsMap = null,
    filterFlags = null,
    aroundMe = null,
    lat = null,
    lng = null,
    withImages = null,
    onlyHasPrice = null,
    onlyPremium = null,
    onlyShops = null,
    onlyMemberships = null,
    orderMode = null,
    sort = null,
    priceFrom = null,
    priceTo = null,
    currency = null,
    similarSerp = null,
    recommendedSerp = null,
    landingPopup = null,
    includeSelf = null,
  } = {},
  locale = getLang()
) => {
  if (["phone", "id", "all", null].indexOf(search_type) === -1) {
    throw new Error(
      `search_type: ${["phone", "id", "all", null].join(
        ","
      )} are accepted only, "${search_type}" is used instead`
    );
  }

  let dynamicAttributes =
    dynamicAttributesObjects.length === 0
      ? null
      : dynamicAttributesObjects.reduce((state, currentItem) => {
          if (!currentItem?.option_id) return state;
          state[currentItem?.field_name] = state[currentItem.field_name] || [];
          state[currentItem?.field_name].push(currentItem.option_id);
          return state;
        }, {});
  dynamicAttributes = { ...dynamicAttributes, ...dynamicAttributesIds };
  const PostSearch = {
    cityId:
      cities.filter(Boolean).length === 0
        ? null
        : cities
            .filter(Boolean)
            .map((city) => city.id)
            .join(","),
    neighborhood_id:
      neighborhoods.filter(Boolean).length === 0
        ? null
        : neighborhoods
            .filter(Boolean)
            .map((nHood) => nHood?.id)
            .join(","),
    categoryId: category?.id,
    categoriesId,
    subCategoryId: subCategory?.id,
    dynamicAttributes,
    search_type,
    withImages: withImages ? "true" : null,
    onlyHasPrice: onlyHasPrice ? "true" : null,
    onlyPremium: onlyPremium ? "true" : null,
    onlyShops: onlyShops ? "true" : null,
    onlyMemberships: onlyMemberships ? "true" : null,
    priceFrom,
    priceTo,
    price_currency: currency?.id || null,
    lat,
    lng,
    orderMode,
    sort,
  };

  const queryString = qsStringify({
    ...(page && page > 1 ? { page } : {}),
    basePath,
    allCPsMap,
    filterFlags,
    PostSearch,
    aroundMe,
    term: term ? term : null,
    similarSerp: similarSerp ? similarSerp : null,
    recommendedSerp: recommendedSerp ? recommendedSerp : null,
    includeSelf: includeSelf ? includeSelf : null,
    "landing-popup": landingPopup ? landingPopup : null
  });
  return `/${locale}/find${queryString}`;
};

export const _qsUnlinkableCPS = ({ dynamicAttributesObjects = [] } = {}) => {
  let dynamicAttributes = dynamicAttributesObjects.reduce((acc, item) => {
    const { id, fieldName } = item;
    if (acc[fieldName]) {
      acc[fieldName].push(id);
    } else {
      acc[fieldName] = [id];
    }
    return acc;
  }, {});

  // todo : remove this function and use qsStringify instead , figure out how to remove [0] [1] and use ","
    function objectToQueryString(obj) {
        return Object.entries(obj)
            .map(([key, value]) => {
                if (Array.isArray(value)) {
                    return `${key}=${value.join(",")}`;
                }
                return `${key}=${value}`;
            })
            .join("&");
    }
  return objectToQueryString(dynamicAttributes);
};

export const linkToDLP = (dlpSlug: string, page = null) => {
  const locale = getLang();
  return `/${locale}/dlp/${dlpSlug}${qsStringify({
    page,
  })}`;
};

export const linkToListing = (
  objects,
  withLang = true,
  page = null,
  prefix = ""
) => {
  const locale = getLang();
  const hrefLink = objects.map(urlHelper).filter(Boolean).join("/");
  const qsString = qsStringify({ page });
  return `/${withLang ? locale + "/" : ""}${
    prefix ? `${prefix}/` : ""
  }${hrefLink}${qsString}`;
};
export const linkToCustomListing = (
  // merge me with linkToListing function
  basePath,
  objects,
  withLang = true,
  page = null,
  prefix = ""
) => {
  // const customPageUriParts=  customPageUri?.split("/").filter(Boolean);
  // const uri=  customPageUriParts[customPageUriParts.length - 1];

  objects.push({ url_name: basePath });
  objects.push({ url_name: "all" });

  const locale = getLang();
  const urlParts = objects.map(urlHelper).filter(Boolean).join("/").split("/");
  const href = [...new Set(urlParts)].join("/");
  const qsString = qsStringify({ page });
  return `/${withLang ? locale + "/" : ""}${
    prefix ? `${prefix}/` : ""
  }${href}${qsString}`;
};

export const linkToVirtualCat = (
  virtualCat: IVirtualCatAsset,
  city: ICityLiteAsset
): Array<string> => {
  const locale = getLang();
  const url = trField(virtualCat, "buyer_weblink").replace(/\/(ar|en)/, "");
  let href = `/${locale}/${url}`
    .replace("/__market_name__", "/" + urlHelper(city))
    .replace("//", "/")
    .replace("//", "/");

  let goTo;
  if (
    virtualCat.reporting_name !== "Shops" &&
    virtualCat.reporting_name !== "AllCategories"
  ) {
    goTo = href;
  }

  return [href, goTo];
};

export const newLinkToFindBuilder = (locale, categories, subCategory, reportingName, categoriesForBrands) => {
    const cat =  locale === "en" ? categories[reportingName].url : categories[reportingName].url_ar
    return `/${locale}/${cat}/${subCategory[`url_name_${locale}`]}?search=true&term=${labelHelper(categoriesForBrands.brand)}`
}

export const linkToListingWithCustomParam = (
    objects,
    withLang = true,
    page = null,
    prefix = ""
) => {
    const locale = getLang();
    const href = objects.map(urlHelperWithoutCustomParam).filter(Boolean).join("/");
    const qsString = objects.map(urlHelperWithCustomParam).filter(Boolean).join("&");
    return `/${withLang ? locale + "/" : ""}${
        prefix ? `${prefix}/` : ""
    }${href}${qsString ? "?search=true&" + qsString : ""}`;
};